import React from 'react';
import styles from 'assets/jss/material-dashboard-pro-react/views/topup/donate';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { BodyS, Button as ButtonFont, HeadingSBold } from 'components/Typography/Typography';
import CardBody from 'components/Card/CardBody';
import Card from 'components/Card/Card';
import CardGiftcard from '@material-ui/icons/CardGiftcard';
import { translate } from 'components/Translation';
import classNames from 'classnames';
import CustomToggle from 'components/CustomToggle/CustomToggle';

// @ts-ignore
const useStyles = makeStyles(styles);

interface IDonateProps {
	showDonations: boolean;
	onChangeShowDonations: () => void;
}

const Donate = ({ showDonations, onChangeShowDonations }: IDonateProps) => {
	const classes = useStyles();
	const iconClasses = classNames(classes.iconWrapper);

	return (
		<div className={classes.donationWrapper}>
			<div>
				<div className={classes.donateWrapper}>
					<div className={classes.backgroundCard}>
						<div className={classes.backgroundCardBody}>
							<div className={classes.textWrapper}>
								<HeadingSBold disableMargin>{translate('donations.background.title')}</HeadingSBold>
								<div className={classes.backgroundCardDescription}>
									<BodyS color="secondary-light" disableMargin>
										{translate('donations.background.description')}
									</BodyS>
								</div>
							</div>
							<div className={classes.backgroundCardActions}>
								<CustomToggle
									label={translate('topup.donate.header')}
									formControlProps={{
										labelPlacement: 'start',
										id: 'donations-switch',
									}}
									checked={showDonations}
									value=""
									onChange={() => onChangeShowDonations()}
								/>
							</div>
						</div>
					</div>
					<Card className={classes.exposedCard}>
						<CardBody gradient="donate" className={classes.exposedCardBody}>
							<div className={classes.exposedCardTitle}>
								<ButtonFont color="primary-dark" disableMargin>
									{translate('donations.exposed.cta')}
								</ButtonFont>
							</div>
							<div className={iconClasses}>
								<CardGiftcard />
							</div>
						</CardBody>
					</Card>
				</div>
			</div>
		</div>
	);
};

export default Donate;
